var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 1H19V0L18 0V1ZM7.293 10.293C7.11084 10.4816 7.01005 10.7342 7.01233 10.9964C7.0146 11.2586 7.11977 11.5094 7.30518 11.6948C7.49059 11.8802 7.7414 11.9854 8.0036 11.9877C8.2658 11.99 8.5184 11.8892 8.707 11.707L7.293 10.293ZM10 2L18 2V0L10 0V2ZM17 1V9H19V1H17ZM17.293 0.293L7.293 10.293L8.707 11.707L18.707 1.707L17.293 0.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6 2C4.13 2 3.196 2 2.5 2.402C2.04398 2.66529 1.66529 3.04398 1.402 3.5C1 4.196 1 5.13 1 7V12C1 14.828 1 16.243 1.879 17.121C2.757 18 4.172 18 7 18H12C13.87 18 14.804 18 15.5 17.598C15.956 17.3347 16.3347 16.956 16.598 16.5C17 15.804 17 14.87 17 13",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.538c3cf784f96896c06201893a1fa641.svg";
export { ForwardRef as ReactComponent };